"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSelectWithInputWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledSelectWithInputWrapper = _styledComponents.default.div.withConfig({
  displayName: "SelectWithInputstyles__StyledSelectWithInputWrapper",
  componentId: "sc-4q0zqj-0"
})(["", ";", ";"], function (props) {
  return props._inStyleGuide ? 'padding: 0 1rem' : '';
}, function (props) {
  return props._inStyleGuide ? 'margin: 0 1rem' : '';
});

exports.StyledSelectWithInputWrapper = StyledSelectWithInputWrapper;